import { useState } from 'react';
import dayjs from 'dayjs';
import { computed } from 'mobx';

import { OrdersDataStore } from '../cabinet/features/orders/orders.store';
import { EOrderStatus, TStationName } from '../orders/core/order';

export const checkMoreThreeDaysAfterTrip = (date: string) => {
  if (date === '') return true;

  const now = dayjs();
  const threeDaysAgo = now.subtract(3, 'day');
  const result = dayjs(date).isBefore(threeDaysAgo);

  return result;
};

type TBaseOrderFeedback = {
  arrivalTime: string;
  departureTime: string;
  stationFrom: TStationName;
  stationTo: TStationName;
  orderId: number;
};

type TOrderWithFeedback = TBaseOrderFeedback & {
  rating: number;
};

type TOrderWaitingFeedback = TBaseOrderFeedback;

class FeedbackOrdersStore {
  constructor(private ordersStore: OrdersDataStore) {}

  feedbackOrders = computed(() => {
    const withFeedback: TOrderWithFeedback[] = [];
    const waitingFeedback: TOrderWaitingFeedback[] = [];
    const orders = this.ordersStore.orders;

    for (const order of orders) {
      if (order.status !== EOrderStatus.success) continue;

      const ticket = order.tickets.find(
        (ticket) => ticket.orderId === order.id
      );

      if (!ticket) continue;
      // has ticket (arrivalTime and other required data)

      const isTripDone =
        new Date(ticket.arrivalTime || Date.now() + 1000) < new Date();

      if (!isTripDone) continue;
      // has ticket (arrivalTime and other required data)

      // has feedback
      if (order.feedback !== null) {
        const orderFeedback: TOrderWithFeedback = {
          arrivalTime: ticket.arrivalTime,
          departureTime: ticket.departureTime,
          orderId: order.id,
          rating: order.feedback.rating,
          stationFrom: ticket.stationFrom,
          stationTo: ticket.stationTo,
        };

        withFeedback.push(orderFeedback);
        continue;
      }

      // waiting for feedback
      if (order.feedback === null) {
        const isMoreThreeDaysAfterTrip = checkMoreThreeDaysAfterTrip(
          ticket.arrivalTime
        );

        if (isMoreThreeDaysAfterTrip) continue;

        const orderFeedback: TOrderWaitingFeedback = {
          arrivalTime: ticket.arrivalTime,
          departureTime: ticket.departureTime,
          orderId: order.id,
          stationFrom: ticket.stationFrom,
          stationTo: ticket.stationTo,
        };

        waitingFeedback.push(orderFeedback);
        continue;
      }
    }

    return { withFeedback, waitingFeedback };
  });
}

type UseOrdersFeedbackParams = {
  ordersStore: OrdersDataStore;
};
export const useOrdersFeedback = ({ ordersStore }: UseOrdersFeedbackParams) => {
  const [store] = useState(() => new FeedbackOrdersStore(ordersStore));

  return store;
};
